export function WhatMakesDifferent() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const principles = [
    {
      title: 'We start with the rules, not the listing',
      description: 'Before creating any rental strategy, we thoroughly review your city bylaws, zoning regulations, and strata restrictions to ensure full compliance from day one.'
    },
    {
      title: 'We verify city bylaws and strata permissions',
      description: 'Every property is different. We conduct detailed research into your specific building, location, and ownership structure to identify what\'s legally permitted.'
    },
    {
      title: 'We design strategies that survive inspections',
      description: 'Our rental plans are built to withstand scrutiny from city inspectors, strata councils, and neighbor complaints. No shortcuts, no gray areas.'
    },
    {
      title: 'We prioritize long-term flexibility over short-term risk',
      description: 'Quick profits aren\'t worth losing your licence or facing fines. We focus on sustainable rental strategies that protect your property and your future.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="sticky top-32">
              <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] leading-tight">
                Compliance first, always
              </h2>
              <div className="w-1 h-32 bg-[#882629] mt-8 ml-2"></div>
              <p className="text-sm text-[#505A5A]/60 mt-8 italic leading-relaxed">
                Based on current 2026 BC Short Term Rental regulations and municipal enforcement policies.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-6 mb-10">
              {principles.map((principle, index) => (
                <div 
                  key={index}
                  className="border border-[#F0F0F0] rounded-2xl p-8 hover:shadow-lg transition-shadow relative pl-10"
                >
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#882629] rounded-l-2xl"></div>
                  <h3 className="text-xl font-semibold text-[#505A5A] mb-3">
                    {principle.title}
                  </h3>
                  <p className="text-base text-[#505A5A]/70 leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="bg-[#F0F0F0] rounded-2xl p-8 mb-8">
              <p className="text-lg text-[#505A5A] leading-relaxed italic font-['Fraunces']">
                There is no government website that tells you if your property can be rented short-term. Most owners are guessing. We remove the guesswork and build a plan that fits your property, your lifestyle, and the law.
              </p>
            </div>

            <button 
              onClick={scrollToContact}
              className="bg-[#882629] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              Get a compliance assessment
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}